export interface UserInfoData {
  company: string;
  titleCode: string;
  salutationCode: string;
  firstName: string;
  lastName: string;
  line1: string; // Line 1 contains house number and street
  additionalLine1: string | null; // Additional address line (displayed after Line1)
  line2: string; // Line2 contains the city, region and postalcode
  zipCode: string;
  city: string;
  country: string;
  phone: string;
  email: string;
  updateUser?: boolean;
  registered?: boolean;
}

export interface SalesPartnerInfo {
  name: string;
  displayName: string;
  line1: string;
  line2: string;
  zipCode: string;
  city: string;
  country: string;
  affiliateId: string;
  subsidiaryId: string;
  phone: string;
  fax: string;
  email: string;
}

export enum SALUTATION_CODES {
  MR = "mr",
  MS = "ms",
  DIVERSE = "diverse",
  PREFER_NOT_TO_SAY = "diverse2",
}
